import React, { useMemo, useEffect, useState } from 'react';
import { debounce, get } from 'lodash';
import TextField from '../../../../common/components/TextField/TextField';
import Select from '../../../../common/components/Select/Select';
import MenuItem from '../../../../common/components/MenuItem/MenuItem';

export const makePersistedTextFilter = (debounceMs = 500) =>
  function PersistedTextFilter({ filter, onChange, ...rest }) {
    const valueFromState = get(filter, 'value', '');
    const [localValue, setLocalValue] = useState(valueFromState);

    useEffect(() => {
      setLocalValue(valueFromState);
    }, [valueFromState]);

    const forwardChange = useMemo(() => debounce(onChange, debounceMs), [onChange, debounceMs]);

    return (
      <TextField
        fullWidth
        value={localValue}
        onChange={(e) => {
          const nextValue = e.target.value;
          setLocalValue(nextValue);
          forwardChange(nextValue);
        }}
        {...rest}
      />
    );
  };

export const makePersistedSelectFilter = (options) =>
  function PersistedSelectFilter({ filter, onChange }) {
    const valueFromState = get(filter, 'value', '');
    const [localValue, setLocalValue] = useState(valueFromState);

    useEffect(() => {
      setLocalValue(valueFromState);
    }, [valueFromState]);

    return (
      <Select
        fullWidth
        autoWidth
        displayEmpty
        value={localValue}
        onChange={(e) => {
          const nextValue = e.target.value;
          setLocalValue(nextValue);
          onChange(nextValue);
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    );
  };

export const makePersistedNumberFilter = (debounceMs = 500) =>
  function PersistedNumberFilter({ filter, onChange, ...rest }) {
    const valueFromState = get(filter, 'value', '');
    const [localValue, setLocalValue] = useState(valueFromState);

    useEffect(() => {
      setLocalValue(valueFromState);
    }, [valueFromState]);

    const forwardChange = useMemo(() => debounce(onChange, debounceMs), [onChange, debounceMs]);

    return (
      <TextField
        fullWidth
        value={localValue}
        onChange={(e) => {
          const digitsOnly = (e.target.value || '').replace(/\D+/g, '');
          setLocalValue(digitsOnly);
          forwardChange(digitsOnly);
        }}
        other={{ inputProps: { inputMode: 'numeric', pattern: '[0-9]*' } }}
        {...rest}
      />
    );
  };
